export const initialState = {
  currentStep: 0,
  score: 0,
  rawAnswers: {},
  status: 'mode_selection',
  mode: null,
  sectionStarted: false,
};

export function scaleRunnerReducer(state, action) {
  switch (action.type) {
    case 'SET_STATUS':
      return { ...state, status: action.payload };
      
    case 'SET_MODE':
      return { ...state, mode: action.payload, sectionStarted: true, status: 'mode_selection' };
      
    case 'RESET_SECTION':
      return { ...state, sectionStarted: false, mode: null, status: 'mode_selection' };
      
    case 'RECORD_ANSWER': {
      const { questionId, answer, points } = action.payload;
      return {
        ...state,
        rawAnswers: { ...state.rawAnswers, [questionId]: answer },
        score: state.score + (points || 0)
      };
    }
    
    case 'NEXT_STEP':
      return { ...state, currentStep: state.currentStep + 1, status: 'mode_selection' };
      
    case 'FINISH':
      return { ...state, status: 'finished' };
      
    case 'PAUSE':
      return { ...state, status: 'paused' };
      
    default:
      return state;
  }
}